import { transition } from '@hover/blueprint';
import type { ChakraProps, SystemStyleObject } from '@hover/blueprint/chakra';
import { resetFocus } from '@hover/blueprint/foundation';
import React from 'react';

import type { ButtonProps } from 'src/shared/components/Button';
import { Button } from 'src/shared/components/Button';
import { TranslationNamespace, useTranslate } from 'src/shared/hooks';

export interface SelectionProps {
  isSelected?: boolean;
  offset?: string;
  sx?: SystemStyleObject;
}

export interface SelectionButtonProps extends ButtonProps, SelectionProps {}

export const selectionStyles = ({ isSelected, sx }: SelectionProps) => {
  const halo = isSelected ? 'neutral.900' : 'transparent';

  return {
    _hover: {
      outlineColor: 'neutral.300',
    },
    _focusVisible: {
      outlineColor: 'neutral.900',
    },
    outline: '2px solid transparent',
    outlineOffset: '2px',
    background: isSelected ? 'transparent' : 'neutral.200',
    borderWidth: '0',
    overflow: 'visible',
    padding: '0px',
    outlineColor: halo,
    ...transition.easing250('outlineColor'),
    sx: { ...sx, ...resetFocus({ outlineColor: halo }) } as SystemStyleObject,
  } satisfies ChakraProps;
};

export const SelectionButton = ({
  isSelected,
  offset,
  ...props
}: SelectionButtonProps) => {
  const t = useTranslate(TranslationNamespace.DESIGN_STUDIO);

  return (
    <Button
      aria-pressed={isSelected}
      label={t('components.selectionButton')}
      {...props}
      {...selectionStyles({ isSelected, offset })}
      shape="circle"
    />
  );
};
